import React from 'react';
import { Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import CommonTable from '../../common/components/CommonTable';
import CommonLoader from '../../common/components/CommonLoader';
import LocationsTableRow from './LocationsTableRow';

const headers = [
  {
    label: 'city',
  },
  {
    label: 'Users',
  },
  {
    label: 'Percent',
  },
  {
    label: 'Actions',
  },
];

function LocationsTable({ data, offset, changeOffset }) {
  const loaderStatus = useSelector((state) => state.locations.get('loaderStatus'));
  return (
    <Row>
      <Col xs="12">
        <CommonLoader status={loaderStatus}>
          <CommonTable
            className="locations-table"
            rowComponent={LocationsTableRow}
            data={data}
            offset={offset}
            onOffsetChange={changeOffset}
            headers={headers}
            title="Locations"
            hasRowPointer={false}
          />
        </CommonLoader>
      </Col>
    </Row>
  );
}

LocationsTable.propTypes = {
  data: PropTypes.object.isRequired,
  offset: PropTypes.number.isRequired,
  changeOffset: PropTypes.func.isRequired,
};

export default LocationsTable;
